import { render, staticRenderFns } from "./OrganisationsConsole.vue?vue&type=template&id=073e2eff&scoped=true&"
import script from "./OrganisationsConsole.vue?vue&type=script&lang=js&"
export * from "./OrganisationsConsole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073e2eff",
  null
  
)

export default component.exports